import { type Transaction as TransactionGenerated } from "~/api/generated";

import { PageKind, ViewKind } from "./enums";
import type { Page } from "./types";

export { type TransactionResponse, TransactionsService } from "~/api/generated";
export { type ApiResult } from "~/api/generated/core/ApiResult";

export type Transaction = Omit<TransactionGenerated, "duid"> & {
  duid: string;
};

export const isDefined = <T>(item: T | null | undefined): item is T => item !== null && item !== undefined;

export const isLeftbarVisible = (currentPage: Page | undefined) => {
  if (!currentPage) {
    return false;
  }

  return (
    currentPage.pageKind === PageKind.INBOX ||
    currentPage.pageKind === PageKind.HOME ||
    (currentPage.pageKind === PageKind.VIEW && currentPage.kind !== ViewKind.CUSTOM)
  );
};

export const isBackNavigationAllowed = (currentPage: Page | undefined) => {
  if (!currentPage) {
    return false;
  }

  const allowedPageKinds = [
    PageKind.DARTBOARD,
    PageKind.DASHBOARD,
    PageKind.DASHBOARDS_ROOT,
    PageKind.FOLDER,
    PageKind.NOT_FOUND,
    PageKind.SPACE,
    PageKind.VIEWS_ROOT,
  ];

  return (
    allowedPageKinds.includes(currentPage.pageKind) ||
    (currentPage.pageKind === PageKind.VIEW && currentPage.kind === ViewKind.CUSTOM)
  );
};
